import script from "./PreisSprung.vue?vue&type=script&setup=true&lang=js"
export * from "./PreisSprung.vue?vue&type=script&setup=true&lang=js"

import "./PreisSprung.vue?vue&type=style&index=0&id=a8dbf08a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a8dbf08a"]])

export default __exports__